"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClientName;
(function (ClientName) {
    ClientName["AP"] = "Aftenposten";
    ClientName["ASK"] = "Ask\u00F8yv\u00E6ringen";
    ClientName["BTI"] = "Bergens Tidende";
    ClientName["BYN"] = "Bygdanytt";
    ClientName["DNB"] = "DNB";
    ClientName["DP"] = "E24 Dine Penger";
    ClientName["MPL"] = "Magasin+";
    ClientName["SA"] = "Stavanger Aftenblad";
    ClientName["SCH"] = "Schibsted";
    ClientName["STR"] = "Strilen";
    ClientName["VG"] = "VG";
    ClientName["VNY"] = "Vestnytt";
    ClientName["E24"] = "e24";
    ClientName["BEDRIFT"] = "Min Bedrift";
    ClientName["SVD"] = "SVD";
    ClientName["OMNI"] = "Omni";
    ClientName["WELLOBE"] = "Wellobe";
    ClientName["AB"] = "Aftonbladet";
    ClientName["VEKTKLUBB"] = "Vektklubb";
})(ClientName || (ClientName = {}));
exports.default = ClientName;
//# sourceMappingURL=ClientName.js.map